<script setup lang="ts">
import { useFormValidation } from '../../../../composables/useFormValidation'
import { required } from '../../../../utils/validation'
import TextInput from '../../../../components/ui/form/TextInput.vue'
import { api } from '../../../../api/Api'
import Toast from '../../../../services/Toast'
import { Permission } from '../../../../types/auth'
import { ref, onMounted } from 'vue'
import ModalFormTemplate from '../../../../components/ui/Templates/ModalFormTemplate.vue'
import AsyncImage from '../../../../components/ui/form/AsyncImage.vue'
import DataTable from '../../../../components/table/DataTable.vue'
import GridInput from '../../../../components/ui/form/GridInput.vue'
import UpdatePriceForm from './UpdatePriceForm.vue'
import Buttons from '../../../../components/ui/form/Buttons.vue';
import ItemsForm from '../../../inventory/itemmanagement/items/ItemsForm.vue'
import {
  getPermissionList,
  hasPermission,
  printPDFBlob,
} from "../../../../utils/CommonFunctions";
import FileUpload from '../../../../components/ui/form/FileUpload.vue'

const props = defineProps<{
  data?: any | null
  mode: 'create' | 'edit' | 'view' | 'showQuickView' | 'toggleStatus'
  title: string | null
  endPoint: string,  
  listCreateName?: string
  showInventory?: boolean
  ignorePermission?: boolean  
  price_lists_id?: string | number | null
}>()

const permissions =  ref<Permission[]>([])
const showCost = ref(false)

const emit = defineEmits<{
  (e: 'save', data: any): void
  (e: 'close'): void
}>()

const { fields, formData, setFieldRules, validateForm, resetForm, setFormData } = useFormValidation({
  active: '',
  code: '',
  group_names: '',
  has_variants: '',
  id: '',
  internal_notes: '',
  inventory: [],
  item_variants: {
    active: '',
    code: '',
    id: '',
    inventory: [],
    items_id: '',
    name: '',
    photo: '',
    prices: [],
    uid: '',
    variant_lists_id: '',
    variants_id: '',
  },
  name: '',
  packing_prices: [],
  photo: '',
  prices: [],
  quantity_prices: [],
  sales_name: '',
  tracked_by: '',
  uid: '',
  variant_names: '',
})

setFieldRules('code', [required('Code is required')])
setFieldRules('name', [required('Name is required')])
setFieldRules('id', [required('Item ID is required')])

const handleSubmit = async (close: boolean, newRecord: boolean) => {
  if (validateForm()) {
    const action = formData.value.uid != '' ? 'update' : 'create'
    const response = await api.post((props.endPoint.slice(-1) == '/' ? props.endPoint : props.endPoint + '/') + action, formData.value)
    if (response.success == true) {
      Toast.show('saved successfully')
      emit('save', response.data)
      if (close) {
        emit('close')
      } else if (newRecord) {
        resetForm()
      } else {
        setFormData(response.data)  
      }
    }
  }
}

const prices = ref<any[]>([])
const inventory = ref<any[]>([])

const handleGetData = async () => {
  const response = await api.post("/clients/inventory/item-management/items/record", {
    id: props.data?.uid,
    item_variants_id: props.data?.item_variants_id
  })
    if (response.success == true) {
      setData(response.data)
    } else {
      Toast.show('Error fetching data')
    }
}

const setData = (data: any) => {
  setFormData(data)
  
  console.log('has_variants', data?.has_variants)
  if (data?.has_variants) {
    if (data?.item_variants.photo) {
      setFormData({
        ...data,
        photo: data?.item_variants.photo
      })
    }
    prices.value = data?.item_variants?.prices || []
    inventory.value = data?.item_variants?.inventory || [] 
    fields.value.code.value = fields.value.code.value +  data?.item_variants?.code
    fields.value.name.value = fields.value.name.value +  data?.item_variants?.name
  } else {
    prices.value = data?.prices || []
    inventory.value = data?.inventory || [] 
  }
}
const isReadOnly = ref(true);
const allowEdit = ref(false);
onMounted(() => {
  permissions.value = getPermissionList(props.endPoint)
  allowEdit.value = hasPermission(permissions.value,'Edit')
  showCost.value = hasPermission(permissions.value,'View Cost')
  //console.log('permissions', permissions.value)
  isReadOnly.value = props.mode == 'view'
  if (props.mode == 'create') {
      resetForm()
    } else if (props.data) {
      handleGetData()
    }
})

const showPriceForm = ref(false)
const priceFormMode = ref<'create' | 'edit' | 'view' | 'showQuickView' | 'toggleStatus'>('edit')
const selectedData = ref<any>({})

const handleCustomAction = async (action: string, row: any) => {
  if (action == 'update-price') {    
    priceFormMode.value = 'edit'
    selectedData.value = row
    showPriceForm.value = true
  } else if (action == 'view') {
    selectedData.value = row
    priceFormMode.value = 'view'
    showPriceForm.value = true
  }
}

const handlePriceUpdate = async (data: any) => {
  setData(data)
}

const selectedItem = ref<any>({})
const showItemForm = ref(false)

const handleShowItem = async () => {
  console.log(formData.value, 'handleShowItem')
  console.log(fields.value)
  selectedItem.value = {
    id: formData.value.uid,
  }
  showItemForm.value = true
}

const handlePrintLabel = async () => {
  let selling_price = 0;
  if (props.price_lists_id) {
    const price = prices.value.find((p: any) => p.price_lists_id == props.price_lists_id)
    if (price) {
      selling_price = price.selling_price
    } else {
      Toast.show('Price not found for the selected price list')
      return
    }
  } else {
    selling_price = prices.value[0]?.selling_price
  }
  const response = await api.post(
      (props.endPoint.slice(-1) == "/"
        ? props.endPoint
        : props.endPoint + "/") + "label",
      {
        barcode: formData.value.code,
        name: formData.value.name,
        price: selling_price,
        id: formData.value.uid,
      }
    );
    if (response.success == true) {
      printPDFBlob(response.data);
    }
}

const uploadSucess = async (photo: any) => {
  const response = await api.post(
      (props.endPoint.slice(-1) == "/"
        ? props.endPoint
        : props.endPoint + "/") + "photo-create",
      {
        path: photo,
        items_id: formData.value.id,        
        id: formData.value.uid,
        item_variants_id: formData.value.item_variants?.id,
      }
    );
    if (response.success == true) {
      printPDFBlob(response.data);
    }
}

</script>
<template>
  <ModalFormTemplate :data="data" :mode="mode" :title="title" :endPoint="endPoint" :perm="permissions"
    :listCreateName="listCreateName" :tabList="[]" :formData="formData" @save="handleSubmit" :ignore-permission="ignorePermission"
    @close="$emit('close')">
    <template #header>
      <Buttons v-if="formData.has_variants" icon="Shapes" type="info" caption="View Item with Variants" @click="handleShowItem" />
      <Buttons
      icon="Printer"
      type="secondary"
      caption="Print Label"
      @click="handlePrintLabel"
       />
    </template>
    <template #form>
      <div id="document-section">
        <FileUpload
          label="Photo"
          accept=".png,.jpg,.jpeg"
          :max-size="5"
          :multiple="false"
          :readonly="false"
          v-if="allowEdit"
          @upload-success="uploadSucess"
          :image="true"
          path="items"
          v-model="fields.photo.value"
        />
          <AsyncImage v-else :src="formData?.photo" :alt="fields.photo.value" class-name="w-32 h-32 rounded-lg" />
      </div>
      <div class="grid md:grid-cols-3 gap-6">

        <TextInput v-model="fields.code.value" label="Code" placeholder="Enter Code" :readonly="isReadOnly"
          :error="fields.code.touched ? fields.code.error : null" @blur="fields.code.touched = true" />

        <TextInput v-model="fields.name.value" class="col-span-2" label="Name" placeholder="Enter Name" :readonly="isReadOnly"
          :error="fields.name.touched ? fields.name.error : null" @blur="fields.name.touched = true" />

        <template v-if="formData.has_variants">
          <TextInput v-model="fields.variant_names.value" label="Variant" :readonly="isReadOnly"
          :error="fields.variant_names.touched ? fields.variant_names.error : null" @blur="fields.variant_names.touched = true" />
          <TextInput v-model="fields.item_variants.value.code" label="Variant Code" :readonly="isReadOnly"
          :error="fields.variant_names.touched ? fields.variant_names.error : null" @blur="fields.variant_names.touched = true" />
          <TextInput v-model="fields.item_variants.value.name" label="Variant Name" :readonly="isReadOnly"
          :error="fields.variant_names.touched ? fields.variant_names.error : null" @blur="fields.variant_names.touched = true" />
        
        </template>

        <GridInput label="Prices" class="col-span-3">
          <DataTable :rows="prices" title="Prices" @action="handleCustomAction"
          :permissions="permissions"
          :allow-disable="false"
          :fields="[
            { name: 'price_list', caption: 'Price List', sortable: false, fieldType: 'text' },
            { name: 'selling_price', caption: 'Selling Price', sortable: false, fieldType: 'number' },
            { name: 'inventory_qty', caption: 'Quantity', sortable: false, fieldType: 'number' },
            { name: 'delivery_charges', caption: 'Delviery Charges', sortable: false, fieldType: 'number' },
            { name: 'free_delivery_amount', caption: 'Free Delivery Amount', sortable: false, fieldType: 'number' },          
            { name: 'packing_price', caption: 'Packing Price', sortable: false, fieldType: 'number' },
            { name: 'points', caption: 'Points', sortable: false, fieldType: 'number' },
          ]" :show-header="false" :show-pagination="false" :show-filter="false" :show-actions="true" 
          :actions="[
              {
              name: 'update-price',
              permission: 'Update Prices',
              icon: 'Pencil',
              variant: 'warning',
              title: 'Update Prices',
              visible: () => true,
            },
          ]"
          />
        </GridInput>

        <GridInput label="Inventory" class="col-span-3" v-if="showInventory">
          <DataTable :rows="inventory" title="Inventory" class="col-span-3"
          :showChildRow="true"
          :childRowFields="[
            { name: 'shelf_name', caption: 'Shelf Name', sortable: false, fieldType: 'text' },
            { name: 'on_hand', caption: 'On Hand', sortable: false, fieldType: 'number' },
          ]"
          childRowTitle="Shelfs"
          childRowTableWidth="300px"
          childRowDataField="shelfs"
          :fields="[
            { name: 'warehouse', caption: 'Warehouse', sortable: false, fieldType: 'text' },
            { name: 'on_hand', caption: 'On Hand', sortable: false, fieldType: 'number' },
            { name: showCost ? 'cost' : 'cost1', caption: 'Cost', sortable: false, fieldType: 'number', hide: !showCost},
            { name: 'reorder_level', caption: 'Reorder Level', sortable: false, fieldType: 'number' },
            { name: 'reorder_qty', caption: 'Reorder Qty', sortable: false, fieldType: 'number' },
            { name: 'location', caption: 'Location', sortable: false, fieldType: 'text' },
          ]" :show-header="false" :show-pagination="false" :show-filter="false" :show-actions="false" />
        </GridInput>

        <!--<CheckInput v-model="fields.active.value" :readonly="isReadOnly" label="Active"
          :error="fields.active.touched ? fields.active.error : null" @blur="fields.active.touched = true" />
        -->
          
          
          

      </div>
      <UpdatePriceForm v-if="showPriceForm" :data="selectedData" :mode="priceFormMode" title="Update Price" :endPoint="endPoint" :perm="permissions"
        :listCreateName="listCreateName" @save="handlePriceUpdate" @close="showPriceForm=false" />
    </template>
  </ModalFormTemplate>
  <ItemsForm v-if="showItemForm" :data="formData" mode="view" title="Item Details" @close="showItemForm = false"
  end-point="/clients/inventory/item-management/items/" :ignorePermission="true"/>
</template>